export let PRIMARY_COLOR = "#0075a3";
export let SECONDARY_COLOR = "#008a16";
